import React, { useState, useContext, useEffect, useRef } from 'react';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';
import MembershipRoles from './MembershipRoles';
import { enableDisableUserMembership, fetchOrganizationRoles, removeUserMembership, updateUserMembership } from '../../../../services/b2b-users-apiService';
import SwitchWithTooltip from '../../../b2b-common/SwitchWithTooltip';
import { LoginContext } from '../../../../App';
import { ContentCut, Save } from '@mui/icons-material';
import { callAPIWhileSettingState, generateTextField } from '../../../b2b-common/helpers';
import { Divider } from '@mui/material';

import './Membership.css';

const Membership = ({ membershipData, onClose, onMembershipUpdate, onMembershipRemove }) => {

    const { loginData } = useContext(LoginContext);
    const [member, setMember] = useState(membershipData);
    const [loadingRoles, setLoadingRoles] = useState(false);
    const [organizationRoles, setOrganizationRoles] = useState([]);
    const [loadingSwitch, setLoadingSwitch] = useState(false);
    const [loadingRemoveMember, setLoadingRemoveMember] = useState(false);
    const [loadingSaveMembershipInfo, setLoadingSaveMembershipInfo] = useState(false);

    const userMemberRef = useRef({});
    useEffect(() => {
        if (userMemberRef.current) {
            userMemberRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [])

    useEffect(() => {
        if (member && member.organization && member.organization.organizationUUID) {
            const paramsArray = [
                member.organization.organizationUUID,
                loginData.accessToken
            ];
            callAPIWhileSettingState(fetchOrganizationRoles, paramsArray,
                setLoadingRoles, setOrganizationRoles);
        }
    }, [member.organization.organizationUUID]);

    useEffect(() => {
        onMembershipUpdate(member);
    }, [member.enabled]);

    const handleSwitchToggle = async () => {
        if (member.userId && member.organization.organizationUUID && !loadingSwitch) {
            const paramsArray = [
                member.organization.organizationUUID,
                member.userId,
                !member.enabled,
                loginData.accessToken
            ];
            callAPIWhileSettingState(enableDisableUserMembership, paramsArray,
                setLoadingSwitch, setMember);
        }
    };

    const handleUpdateMembership = async () => {
        if (member.userId && member.organization.organizationUUID && !loadingSaveMembershipInfo) {
            const paramsArray = [
                member.organization.organizationUUID,
                member.userId,
                member,
                loginData.accessToken
            ];
            callAPIWhileSettingState(updateUserMembership, paramsArray,
                setLoadingSaveMembershipInfo, onMembershipUpdate);
            onClose();
        }
    };

    const handleRemoveMember = async () => {
        if (member.userId && member.organization.organizationUUID && !loadingRemoveMember) {
            const paramsArray = [
                member.organization.organizationUUID,
                member.userId,
                loginData.accessToken
            ];
            callAPIWhileSettingState(removeUserMembership, paramsArray, setLoadingRemoveMember, onMembershipRemove);
            onClose();
        }
    };

    const buttonsConfig = [
        {
            label: 'Remove Member',
            confirm: true,
            onConfirm: handleRemoveMember,
            isLoading: loadingRemoveMember,
            color: 'secondary',
            variant: 'contained',
            key: '2',
            icon: <ContentCut />,
        },
        {
            label: 'Save & Close',
            onClick: handleUpdateMembership,
            isLoading: loadingSaveMembershipInfo,
            color: 'primary',
            variant: 'contained',
            key: '1',
            icon: <Save />,
        },
    ];

    return (
        member && (
            <B2BFormContainer title={`${member.user.firstName} ${member.user.lastName} @ ${member.organization.organizationName}`}
                onClose={onClose} buttonsConfig={buttonsConfig} ref={userMemberRef}
                className="user-membership">

                <div className="membership-info">
                    {generateTextField("Email", member.user.email, "membership-info-ro-textfield")}
                    {generateTextField("First Name", member.user.firstName, "membership-info-ro-textfield")}
                    {generateTextField("Last Name", member.user.lastName, "membership-info-ro-textfield")}
                    {generateTextField("Member Since", new Date(member.membershipDate).toLocaleDateString(), "membership-info-ro-textfield")}
                    {generateTextField("Last Login", new Date(member.lastLoginDate).toLocaleString(), "membership-info-ro-textfield")}
                    <div className="membership-switch">
                        <SwitchWithTooltip label="Active" checked={member.enabled}
                            tooltipTitle={`${member.enabled ? 'Deactivate' : 'Activate'} this member`}
                            tooltipPlacement='right'
                            onChange={handleSwitchToggle}
                            loading={loadingSwitch}
                        />
                    </div>
                </div>
                <div className="membership-roles">
                    <Divider orientation='horizontal' flexItem variant='fullWidth' />
                    <MembershipRoles
                        organizationRoles={organizationRoles}
                        memberRoles={member.roles}
                        onUpdateRoles={(roles) => {
                            setMember({ ...member, roles });
                        }}
                    />
                </div>
            </B2BFormContainer>
        )
    );
};

export default Membership;